import { useTracking } from 'react-tracking';
import type { RouterLinkAction } from '@redux-first-router-link';
import type { ReactNode } from 'react';
import { RouterLinkOptimised } from '../RouterLinkOptimised';

type Props = {
  to: RouterLinkAction | undefined;
  title: ReactNode;
  isLast: boolean;
  index: number;
};

export const BreadcrumbListItem = ({ to, title, isLast, index }: Props) => {
  const { Track, trackEvent } = useTracking();

  return (
    <Track>
      <li>
        {to ? (
          <RouterLinkOptimised
            data-cy-id={`child-link-${index}`}
            to={to}
            className="text-xs [color:inherit] hover:text-soft"
            onClick={() =>
              trackEvent({
                action: 'click',
                modifier: 'crumb',
                index: index,
                label: title,
              })
            }
          >
            {title}
          </RouterLinkOptimised>
        ) : (
          <span data-cy-id={`child-link-${index}`} className="text-xs">
            {title}
          </span>
        )}
      </li>
      {!isLast && <li>/</li>}
    </Track>
  );
};
